import React from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import { useLanguage } from "../../context/LanguageContext";
import { useMessengerLinks } from "../../hooks/useMessengerLinks";

function ServiceCard({ icon: Icon, title, bullets }) {
  const { t } = useLanguage();
  const list = Array.isArray(bullets) ? bullets : [];
  const { waDemo } = useMessengerLinks();
  return (
    <Card className="project-card-view h-100">
      <Card.Body className="d-flex flex-column">
        {Icon && (
          <div className="text-center mb-3" aria-hidden>
            <Icon className="purple" size={48} />
          </div>
        )}
        <Card.Title className="text-center">{title}</Card.Title>
        <ul className="text-white-50 text-start small flex-grow-1">
          {list.map((b, i) => (
            <li key={i}>{b}</li>
          ))}
        </ul>
        <Button
          variant="primary"
          className="mt-auto"
          as="a"
          href={waDemo}
          target="_blank"
          rel="noopener noreferrer"
        >
          {t("serviceCard.demo")}
        </Button>
      </Card.Body>
    </Card>
  );
}

export default ServiceCard;
